<template>
  <EStickyFooterLayout>
    <template #header>
      <EMainHeader data-test-id="layout-header">
        <template #navigation>
          <ENavigation />
        </template>
        <template v-if="filtersShown" #filters>
          <EFilters :filters="filters" class="images__search-filters" />
        </template>
      </EMainHeader>
    </template>
    <template #content>
      <Nuxt data-test-id="layout-content" />
    </template>
    <template #footer>
      <EMainFooter
        v-show="endOfFeed || !hasResults"
        :locale="locale"
        data-test-id="layout-footer"
      />
    </template>
  </EStickyFooterLayout>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

import EStickyFooterLayout from '~~/common/vue/components/layouts/sticky-footer';
import EMainHeader from '~~/common/vue/components/main-header';
import EMainFooter from '~~/common/vue/components/main-footer';
import ENavigation from '~~/search/common/vue/components/navigation';
import EFilters from '~~/search/common/vue/components/filters';
import filters from '~/filters';

export default {
  head() {
    return {
      htmlAttrs: { lang: this.$store.state.global.locale },
      title: `${this.$route.query.q || ''} - Ecosia`,
      meta: [
        { hid: 'description', name: 'description', content: this.$t('common.header.share.subheader') },
        { property: 'og:title', name: 'og:title', content: this.$t('common.header.share') },
        { property: 'og:description', name: 'og:description', content: this.$t('common.header.share.subheader') },
      ],
    };
  },
  components: {
    EStickyFooterLayout,
    EFilters,
    ENavigation,
    EMainHeader,
    EMainFooter,
  },
  computed: {
    ...mapState('search', ['filtersShown']),
    ...mapState('global', ['locale']),
    ...mapState(['endOfFeed']),
    ...mapGetters(['hasResults']),
    filters() {
      // enrich the static filter config with translated strings
      return filters.map(this.translateFilter.bind(this));
    },
  },
  methods: {
    getFilterTranslationPrefix(id) {
      return `images.filters.${id}.options.`;
    },
    translateFilterOptions(options, prefix) {
      return options.map((option) => ({
        ...option,
        label: this.$t(`${prefix}${option.value}`),
      }));
    },
    translateFilter(config) {
      const translationPrefix = this.getFilterTranslationPrefix(config.id);
      config.hint = this.$t(`images.filters.${config.id}.hint`);
      config.placeholder = this.$t(`images.filters.${config.id}.placeholder`);
      config.options = this.translateFilterOptions(config.options, translationPrefix);
      if (config.colors) {
        config.colors = this.translateFilterOptions(config.colors, translationPrefix);
      }
      return config;
    },
  },
};
</script>

<style lang="scss" scoped>
.images__search-filters {
  @include desktop {
    margin-bottom: -$space-1s;
    margin-top: $space-1s;
  }
}
</style>
